<template>
	<v-container fluid class="pa-0">
		
		<!-- tables -->
		<div v-if="isLoaded">
			<v-row class="body-2 font-weight-bold ml-12 my-4">
				<span class="ml-4">{{'team' | localize}}: {{ user?.name }}</span>
				<span class="ml-4">{{'current round' | localize}}: {{ game?.round }}</span>
			</v-row>

			<v-divider></v-divider>

			<v-tabs v-model="tab" height="35"
				background-color="primary"
				fixed-tabs
				slider-color="accent"
				dark>
				<v-tab :to="link(item)" 
					class="text-capitalize font-weight-bold white--text"
					v-for="item in items"
					:key="item">
					{{ `${item}`| localize}}
				</v-tab>
			</v-tabs>

			<v-tabs-items v-model="tab" continuous>
				<v-tab-item value="/team/decisions/products">
					<product-management />
				</v-tab-item>
				<v-tab-item value="/team/decisions/sales">
					<sales-plan />
				</v-tab-item>
				<v-tab-item value="/team/decisions/retail">
					<retail />
				</v-tab-item>
				<v-tab-item value="/team/decisions/promotion">
					<promotion />
				</v-tab-item>
				<v-tab-item value="/team/decisions/resources">
					<resources />
				</v-tab-item>
			</v-tabs-items>
		</div>
		<!-- loader -->
		
		<v-row v-else justify="center" class="mt-12">
			<loader />
		</v-row>
	</v-container>
</template>
<script>
import Loader from '../../layouts/Loader.vue'
import ProductManagement from './decisions/ProductManagement.vue';
import Promotion from './decisions/Promotion.vue';
import SalesPlan from './decisions/Sales.vue';
import Retail from './decisions/Retail.vue';


export default {
	data () {
		return {
			tab: 0,
			items: ['Products', 'Sales','Retail','Promotion','Resources'],
			isLoaded: false,
		}
	},
	computed: {
		user() {
			return this.$store.getters.user;
		},
		game () {
			return this.$store.getters.game;
		},
		team() {
			return this.$store.getters.team;
		},
	},
	methods: {
		link (item) {
			return `/team/decisions/${item.toLowerCase()}`
		},
	},
	components: {
			Loader,
			ProductManagement,
			Promotion,
			SalesPlan,
			Retail,
			Resources: () => import('./decisions/Resources.vue'), 
	},
	async created() {
		if (!this.game && this.user) {
			let game_id = this.user.email.match(/\d/g); //get gameId from the user email
			if (typeof game_id == 'object'){
				let id = ''
					
				for( let i=0; i < game_id?.length; i++) {
					id = game_id[i] + id;
				}
				game_id = parseInt(id)
			}
			try {
				await this.$store.dispatch('fetchGame', game_id);
				/* console.log('loading game') */
			}
			catch (error) {
				await this.$store.dispatch('setError', error.message);
			}
		}

		if (!this.team) {
			const name = `${this.user.name}_${this.game.id}`;
			const team = this.game.teams.find(te => te.name == name)
		
			try {
				await this.$store.dispatch('fetchTeam', team.id);
				/* console.log('loading team') */
			}
			catch (error) {
				await this.$store.dispatch('setError', error.message)
			}
		}

		this.isLoaded = true;
	}
}
</script>